<template>
  <v-app>
    <custom-app-bar
      :sidebar="sidebar"
      :items="items"
      :item-icon="itemIcon"
      @sidebar-event="handleSideBar"
    />
    <v-navigation-drawer
      v-model="sidebar"
      app
      dark
      color="primary"
      style="width: 100%"
      src="@/assets/images/texture_circle.png"
    >
      <v-layout column justify-center justify-space-evenly fill-height>
        <div class="">
          <v-list-item>
            <v-list-item-title class="d-flex justify-center align-center">
              <v-img
                src="/img/logo-dedca.png"
                alt="alt"
                class=""
                max-width="150"
              />
            </v-list-item-title>
          </v-list-item>
        </div>
        <v-list dense nav expand class="mt-10 pt-10 mx-16">
          <v-list-item
            v-for="item in items"
            :key="item.title"
            @click="handleNavigation(item)"
          >
            <v-list-item-avatar>
              <v-icon color="white"> mdi-menu </v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="py-3">
              <h3>{{ item.title }}</h3>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-layout>
      <template v-slot:append>
        <div class="pb-16 mb-16 d-flex align-center justify-center">
          <v-btn
            @click="handleSideBar(false)"
            icon
            outlined
            elevation="0"
            color="secondary"
          >
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-main class="pt-0 bg-home">
      <v-row
        id="heading-1"
        align="center"
        :class="$vuetify.breakpoint.mdAndUp ? 'f-h' : ''"
        no-gutters
      >
        <v-col cols="12" md="7" class="">
          <div class="pt-md-15 mt-16 pt-16 mt-md-0 pt-md-0">
            <div
              class="bg-hero"
              :style="
                $vuetify.breakpoint.lgAndUp
                  ? 'max-width: 85%'
                  : $vuetify.breakpoint.md
                  ? 'max-width: 90%'
                  : 'max-width: 80%'
              "
            >
              <h3
                class="pt-4 white--text title-font text-lg-h4 text-md-h5 pl-10 pl-md-15 pr-4"
                data-aos="fade-down"
                data-aos-duration="1500"
              >
                {{ $t("lblHomeDescription") }}
              </h3>
              <h4
                class="pt-6 white--text body-font font-weight-bold text-lg-h6 pl-10 pl-md-15 pr-4"
                data-aos="fade-down"
                data-aos-delay="200"
                data-aos-duration="1500"
              >
                {{ $t("lblHomeDedca") }}
              </h4>
              <p
                class="pt-6 pb-4 mb-0 white--text body-font text-body-1 pl-10 pl-md-15 pr-4"
                data-aos="fade-up"
                data-aos-delay="300"
                data-aos-duration="1500"
              >
                {{ $t("lblHomeSolucion") }}
              </p>
            </div>
            <div class="pl-10 pl-md-15 pt-10">
              <v-btn
                color="custom_blue"
                :x-large="$vuetify.breakpoint.mdAndUp"
                :large="$vuetify.breakpoint.xs"
                dark
                data-aos="fade-up"
                data-aos-duration="1500"
                @click="$vuetify.goTo('#quien-es-blancone')"
              >
                {{ $t("btnQuieroServicios") }}
              </v-btn>
            </div>
          </div>
        </v-col>
        <v-col
          cols="12"
          md="5"
          class="px-10 px-md-12 pt-14 pt-md-0 pb-14 pb-md-0"
        >
          <v-img
            src="/img/logo-blancone.png"
            alt="BlancOne"
            contain
            max-width="230"
            class="mx-auto mb-8 rounded-lg elevation-6"
            data-aos="fade-down"
            data-aos-duration="1500"
          />
          <v-carousel
            cycle
            :interval="4500"
            :height="$vuetify.breakpoint.mdAndUp ? 400 : 280"
            hide-delimiter-background
            show-arrows-on-hover
            class="rounded-xl elevation-12"
            data-aos="fade-left"
            data-aos-duration="1500"
          >
            <v-carousel-item
              v-for="(slide, i) in heroSlides"
              :key="i"
              :src="slide"
            />
          </v-carousel>
        </v-col>
      </v-row>
      <v-row id="quien-es-blancone" class="secondary py-16" no-gutters>
        <v-col
          cols="12"
          md="8"
          class="offset-md-2 px-8 px-md-0 py-10"
          align="center"
        >
          <v-img
            src="/img/logo-blancone.png"
            alt="BlancOne"
            contain
            max-width="250"
            class="mb-10"
            data-aos="fade-down"
            data-aos-duration="1500"
          />
          <h1
            class="primary--text title-font font-weight-bold text-h5 text-md-h4 text-lg-h3 pb-6"
            data-aos="fade-down"
            data-aos-delay="200"
            data-aos-duration="1500"
          >
            {{ $t("titleQuienEsBlancOne") }}
          </h1>
          <h4
            class="support--text body-font font-weight-medium text-h6 pb-10"
            data-aos="fade-up"
            data-aos-delay="300"
            data-aos-duration="1500"
          >
            {{ $t("subtitleQuienEsBlancOne") }}
          </h4>
          <div class="text-left support--text body-font text-body-1">
            <p data-aos="fade-up" data-aos-delay="400" data-aos-duration="1500">
              {{ $t("lblBlancOneHistoria1") }}
            </p>
            <p data-aos="fade-up" data-aos-delay="500" data-aos-duration="1500">
              {{ $t("lblBlancOneHistoria2") }}
            </p>
            <p data-aos="fade-up" data-aos-delay="600" data-aos-duration="1500">
              {{ $t("lblBlancOneHistoria3") }}
            </p>
            <p data-aos="fade-up" data-aos-delay="700" data-aos-duration="1500">
              {{ $t("lblBlancOneHistoria4") }}
            </p>
          </div>
        </v-col>
      </v-row>
      <v-row id="heading-2" class="py-10 py-md-16 px-4 px-md-0" no-gutters>
        <v-col cols="12" md="10" lg="8" class="offset-md-1 offset-lg-2">
          <v-sheet
            color="#F08300"
            class="rounded-xl px-6 px-md-16 py-16"
            elevation="8"
          >
            <v-row no-gutters>
              <v-col cols="12" align="center" class="pb-12">
                <h1
                  class="white--text title-font font-weight-bold text-h5 text-md-h3"
                  data-aos="fade-down"
                  data-aos-delay="300"
                  data-aos-duration="1500"
                >
                  {{ $t("lblPrincipalQueHacemos") }}
                </h1>
                <h5
                  class="white--text body-font pt-6 text-h6 font-weight-regular"
                  data-aos="fade-up"
                  data-aos-delay="400"
                  data-aos-duration="1500"
                >
                  {{ $t("lblSecondaryQueHacemos") }}
                </h5>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                align="center"
                class="px-4 py-6"
                v-for="service in services"
                :key="service.name"
              >
                <individual-service :item="service" />
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>
      <preview-proyects />
      <v-row id="agenda-demo" class="pb-15 pt-10 secondary" align="center">
        <v-col
          cols="12"
          md="5"
          class="offset-md-1 px-10 px-md-4 pt-15"
          align="center"
          data-aos="fade-right"
          data-aos-duration="1500"
        >
          <v-img
            src="/img/homepage_studio2.jpg"
            alt="Sonrisas BlancOne"
            contain
            max-width="520"
            class="rounded-xl"
          />
        </v-col>
        <v-col
          cols="12"
          md="5"
          class="px-10 px-md-8 pt-10 pt-md-15"
          data-aos="fade-left"
          data-aos-duration="1500"
        >
          <h1
            class="primary--text title-font font-weight-bold text-h5 text-md-h4"
          >
            {{ $t("lblQuienesSomosTitle") }}
          </h1>
          <h4 class="font-weight-medium support--text body-font pt-8">
            {{ $t("lblQuienesSomosSubTitle") }}
          </h4>
          <v-btn
            class="mt-10"
            color="primary"
            :x-large="$vuetify.breakpoint.mdAndUp"
            :large="$vuetify.breakpoint.xs"
            dark
            @click="$vuetify.goTo('#heading-6')"
          >
            {{ $t("btnAgendaDemo") }}
          </v-btn>
        </v-col>
      </v-row>
      <contact-us />
    </v-main>
    <custom-footer />
    <v-btn
      fab
      fixed
      bottom
      right
      dark
      color="#25D366"
      href="https://wa.me/50257485870?text=Hola%2C%20me%20gustar%C3%ADa%20m%C3%A1s%20informaci%C3%B3n%20sobre%20los%20blanqueamientos%20BlancOne."
      target="_blank"
      rel="noopener"
      aria-label="WhatsApp"
      class="whatsapp-btn"
    >
      <v-icon large> mdi-whatsapp </v-icon>
    </v-btn>
  </v-app>
</template>
<script>
import CustomFooter from "@/components/Home/CustomFooter";
import CustomAppBar from "@/components/Home/CustomAppBar";
import IndividualService from "@/components/Home/IndividualService";
import PreviewProyects from "@/components/Home/sections/PreviewProyects";
import ContactUs from "@/components/Home/sections/ContactUs";
import vuetify from "@/plugins/vuetify";

export default {
  name: "HomeView",
  components: {
    ContactUs,
    IndividualService,
    CustomAppBar,
    CustomFooter,
    PreviewProyects,
  },
  data: function () {
    return {
      floatingButton: false,
      isMobile: false,
      sidebar: false,
      heroSlides: ["/img/one.jpg", "/img/ultra.jpeg", "/img/arcus.jpeg"],
      itemIcon: {
        tarjet: "#heading-1",
        outlined: true,
        toPage: false,
      },
      items: [
        {
          title: this.$t("titleQuienesSomos"),
          tarjet: "#quien-es-blancone",
          text: true,
          outlined: false,
          toPage: false,
        },
        {
          title: this.$t("titleProducts"),
          tarjet: "#heading-5",
          text: true,
          outlined: false,
          toPage: false,
        },
        {
          title: this.$t("titleContacto"),
          tarjet: "#heading-6",
          text: true,
          outlined: false,
          toPage: false,
        },
      ],
      services: [
        {
          name: this.$t("nameConfortable"),
          url: "/img/iconos/icon_dente.svg",
          urlOrange: "/img/iconos/icon_denteArancio.svg",
          description: "No provoca sensibilidad",
          longDescription:
            "¿Es doloroso? En absoluto, es totalmente seguro y delicado. Con BlancOne CLICK los casos de hipersensibilidad son sumamente raros.",
          width: {
            md: "50%",
            lg: "50%",
          },
        },
        {
          name: this.$t("nameRapido"),
          url: "/img/iconos/icon_time.svg",
          urlOrange: "/img/iconos/icon_OrangeTime.svg",
          description: "Solo 10 minutos",
          longDescription:
            "¿Cuánto tiempo se necesita? Solo 10 minutos. Es el tratamiento ideal para combinarlo con la sesión de higiene oral. Con tan solo 10 minutos más, darás nueva vida y brillo a tu sonrisa.",
          width: {
            md: "60%",
            lg: "50%",
          },
        },
        {
          name: this.$t("nameEconomico"),
          url: "/img/iconos/icon_savemoney.svg",
          urlOrange: "/img/iconos/icon_pigArancio.svg",
          description: "Al alcance de todos",
          longDescription:
            "¿Es caro? ¡En absoluto! Como una cena para dos, una sesión de masaje... ¡BlancOne CLICK está al alcance de todos!",
          width: {
            md: "80%",
            lg: "60%",
          },
        },
        {
          name: this.$t("nameWow"),
          url: "/img/iconos/icon_woweffect.svg",
          urlOrange: "/img/iconos/icon_wowArancio.svg",
          description: "Nuestra garantía",
          longDescription:
            "¿Obtendré resultados inmediatos? Los resultados serán inmediatamente visibles y podrás mejorarlos aún más incorporando el blanqueamiento en tu rutina periódica para el bienestar de la sonrisa.",
          width: {
            md: "80%",
            lg: "60%",
          },
        },
      ],
    };
  },
  methods: {
    vuetify() {
      return vuetify;
    },
    handleSideBar(sidebarValue) {
      this.sidebar = sidebarValue;
    },
    closeNavigation() {
      this.handleSideBar(false);
    },
    handleNavigation(item) {
      if (item.toPage) {
        this.$router.push({ name: item.nameRoute });
      } else {
        this.$vuetify.goTo(item.tarjet);
      }
      if (this.$vuetify.breakpoint.xs) {
        this.handleSideBar();
      }
    },
    onResize() {
      if (window.innerWidth >= 600) {
        this.sidebar = false;
      }
    },
  },
  mounted() {
    this.onResize();
    this.$store.dispatch("projects/getPublicProjects");
  },
  created() {
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>
<style scoped src="@/assets/css/home.css"></style>
<style scoped>
.bg-home {
  background-image: url("~@/assets/images/texture_circle.png"),
    linear-gradient(to right, #009bdc, #1b1464);
  -moz-background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right center;
}

@media (max-width: 600px) {
  .bg-home {
    background-position: right bottom;
  }
}

.bg-hero {
  border-radius: 10px;
}

.whatsapp-btn {
  z-index: 99;
}
</style>
